// ─────────────────────────────────────────────
// Consultauto — Consent & Tracking Manager
// ─────────────────────────────────────────────
// PLACEHOLDERS — Replace these IDs with your real values:
const GA_ID = 'G-9PX5EP78G3';            // Google Analytics 4 Measurement ID
const META_PIXEL_ID = '2471425059926789'; // Meta Pixel ID
const CLARITY_ID = 'w4dm43gl9t';          // Microsoft Clarity Project ID
const TIKTOK_PIXEL_ID = 'D9EBMTRC77U6Q0JCNFCG'; // TikTok Pixel ID
const OPENAI_PIXEL_ID = '3YFKEW32GN8pvFQFvLnXdv'; // OpenAI Ads Pixel ID
const LINKEDIN_PARTNER_ID = '';           // LinkedIn Partner ID — coller l'ID pour activer
// ─────────────────────────────────────────────

const CONSENT_KEY = 'consultauto-consent';

// ── Consent storage ──────────────────────────

export function getConsent() {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function saveConsent(preferences) {
  const data = { ...preferences, essential: true, timestamp: new Date().toISOString() };
  localStorage.setItem(CONSENT_KEY, JSON.stringify(data));
  applyConsent(data);
  return data;
}

export function acceptAll() {
  return saveConsent({ essential: true, analytics: true, marketing: true });
}

export function refuseAll() {
  return saveConsent({ essential: true, analytics: false, marketing: false });
}

export function hasConsented() {
  return getConsent() !== null;
}

// ── Apply consent (load scripts) ─────────────

export function applyConsent(consent) {
  if (!consent) return;
  if (consent.analytics) {
    initGA4();
    initClarity();
  }
  if (consent.marketing) {
    initMetaPixel();
    initTikTok();
    initOpenAIPixel();
    initLinkedIn();
  }
}

export function bootConsentOnLoad() {
  const consent = getConsent();
  if (consent) applyConsent(consent);
}

// ── Google Analytics 4 ───────────────────────

function initGA4() {
  if (!GA_ID || GA_ID === 'G-XXXXXXXXXX') return;
  if (window.gtag) return;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  window.gtag('config', GA_ID, { send_page_view: true });
}

// ── Meta Pixel ───────────────────────────────

function initMetaPixel() {
  if (!META_PIXEL_ID || META_PIXEL_ID === 'XXXXXXXXXX') return;
  if (window.fbq) return;

  /* eslint-disable */
  !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){
    n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;
    s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(
    window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */
  window.fbq('init', META_PIXEL_ID);
  window.fbq('track', 'PageView');
}

// ── OpenAI Ads Pixel ─────────────────────────

function initOpenAIPixel() {
  if (!OPENAI_PIXEL_ID || window.oaiq) return;

  /* eslint-disable */
  !function (w, d, s, u) {
    if (w.oaiq) return;
    var q = function () { q.q.push(arguments) }; q.q = []; w.oaiq = q;
    var j = d.createElement(s); j.async = 1; j.src = u;
    var f = d.getElementsByTagName(s)[0]; f.parentNode.insertBefore(j, f);
  }(window, document, 'script', 'https://bzrcdn.openai.com/sdk/oaiq.min.js');
  window.oaiq('init', { pixelId: OPENAI_PIXEL_ID, debug: false });
  /* eslint-enable */
}

// ── TikTok Pixel ─────────────────────────────

function initTikTok() {
  if (!TIKTOK_PIXEL_ID || window.ttq) return;

  /* eslint-disable */
  !function (w, d, t) {
    w.TiktokAnalyticsObject = t; var ttq = w[t] = w[t] || [];
    ttq.methods = ["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"];
    ttq.setAndDefer = function (t, e) { t[e] = function () { t.push([e].concat(Array.prototype.slice.call(arguments, 0))) } };
    for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
    ttq.instance = function (t) { var e = ttq._i[t] || [], n; for (n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n]); return e };
    ttq.load = function (e, n) {
      var r = "https://analytics.tiktok.com/i18n/pixel/events.js", o = n && n.partner;
      ttq._i = ttq._i || {}; ttq._i[e] = []; ttq._i[e]._u = r; ttq._t = ttq._t || {}; ttq._t[e] = +new Date; ttq._o = ttq._o || {}; ttq._o[e] = n || {};
      n = document.createElement("script"); n.type = "text/javascript"; n.async = !0; n.src = r + "?sdkid=" + e + "&lib=" + t;
      e = document.getElementsByTagName("script")[0]; e.parentNode.insertBefore(n, e)
    };
    ttq.load(TIKTOK_PIXEL_ID); ttq.page();
  }(window, document, 'ttq');
  /* eslint-enable */
}

// ── LinkedIn Insight Tag ─────────────────────

function initLinkedIn() {
  if (!LINKEDIN_PARTNER_ID || window.lintrk) return;

  window._linkedin_partner_id = LINKEDIN_PARTNER_ID;
  window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
  window._linkedin_data_partner_ids.push(LINKEDIN_PARTNER_ID);
  /* eslint-disable */
  (function (l) {
    if (!l) { window.lintrk = function (a, b) { window.lintrk.q.push([a, b]) }; window.lintrk.q = [] }
    var s = document.getElementsByTagName("script")[0];
    var b = document.createElement("script");
    b.type = "text/javascript"; b.async = true;
    b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
    s.parentNode.insertBefore(b, s);
  })(window.lintrk);
  /* eslint-enable */
}

// ── Microsoft Clarity ────────────────────────

function initClarity() {
  if (!CLARITY_ID || CLARITY_ID === 'XXXXXXXXXX') return;
  if (window.clarity) return;

  /* eslint-disable */
  (function(c,l,a,r,i,t,y){
    c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
    t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
    y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
  })(window,document,"clarity","script",CLARITY_ID);
  /* eslint-enable */
}

// ── Event tracking ───────────────────────────
// Standard event mapping for retargeting audiences (Meta 2026 standards)
const META_STANDARD_EVENTS = {
  booking_lead: 'Lead',
  slot_selected: 'InitiateCheckout',
  booking_success: 'Schedule',
  booking_viewed: 'ViewContent',
};

const TIKTOK_STANDARD_EVENTS = {
  booking_lead: 'SubmitForm',
  slot_selected: 'InitiateCheckout',
  booking_success: 'CompleteRegistration',
  booking_viewed: 'ViewContent',
};

const OPENAI_STANDARD_EVENTS = {
  booking_lead: 'lead_created',
  booking_success: 'appointment_scheduled',
};

export function trackEvent(eventName, params = {}) {
  // GA4
  if (window.gtag) {
    window.gtag('event', eventName, params);
  }
  // Meta Pixel — standard events for audience building, custom otherwise
  if (window.fbq) {
    const std = META_STANDARD_EVENTS[eventName];
    if (std) {
      window.fbq('track', std, params);
    } else {
      window.fbq('trackCustom', eventName, params);
    }
  }
  // TikTok Pixel — standard events only
  if (window.ttq) {
    const tt = TIKTOK_STANDARD_EVENTS[eventName];
    if (tt) window.ttq.track(tt, {});
  }
  // OpenAI Ads Pixel — conversion events (lead + rendez-vous)
  if (window.oaiq) {
    const oa = OPENAI_STANDARD_EVENTS[eventName];
    if (oa) window.oaiq('measure', oa, { type: 'customer_action', amount: 0, currency: 'CAD' });
  }
}

// Advanced Matching (Meta) + Enhanced Conversions (Google) — max lead tracking
export function identifyUser({ email, phone, firstName, lastName } = {}) {
  const consent = getConsent();
  if (!consent || !consent.marketing) return;
  try {
    if (window.fbq) {
      const am = {};
      if (email) am.em = email.trim().toLowerCase();
      if (phone) { const d = phone.replace(/\D/g, ''); am.ph = d.length === 10 ? `1${d}` : d; }
      if (firstName) am.fn = firstName.trim().toLowerCase();
      if (lastName) am.ln = lastName.trim().toLowerCase();
      window.fbq('init', META_PIXEL_ID, am);
    }
    if (window.gtag) {
      window.gtag('set', 'user_data', {
        email: email ? email.trim().toLowerCase() : undefined,
        phone_number: phone ? `+1${phone.replace(/\D/g, '')}` : undefined,
        address: { first_name: firstName || undefined, last_name: lastName || undefined },
      });
    }
    if (window.ttq && (email || phone)) {
      const idData = {};
      if (email) idData.email = email.trim().toLowerCase();
      if (phone) { const d = phone.replace(/\D/g, ''); idData.phone_number = `+${d.length === 10 ? '1' + d : d}`; }
      window.ttq.identify(idData);
    }
  } catch {}
}

export function trackPageView(path) {
  if (window.gtag) {
    window.gtag('event', 'page_view', { page_path: path });
  }
  if (window.fbq) {
    window.fbq('track', 'PageView');
  }
  if (window.ttq) {
    window.ttq.page();
  }
}
